export var TypeActionContractInfo;
(function (TypeActionContractInfo) {
    TypeActionContractInfo["Request"] = "ContractInfo > Request";
    TypeActionContractInfo["Received"] = "ContractInfo > Received";
    TypeActionContractInfo["RequestFulfill"] = "ContractInfo > RequestFulfill";
    TypeActionContractInfo["Fulfill"] = "ContractInfo > Fulfill";
    TypeActionContractInfo["RequestDismiss"] = "ContractInfo > RequestDismiss";
    TypeActionContractInfo["RequestSkip"] = "ContractInfo > RequestSkip";
    TypeActionContractInfo["Skip"] = "ContractInfo > Skip";
    TypeActionContractInfo["StartCooldown"] = "ContractInfo > StartCooldown";
    TypeActionContractInfo["FinishCooldown"] = "ContractInfo > FinishCooldown";
})(TypeActionContractInfo || (TypeActionContractInfo = {}));
export var actionContractInfo = function (props) { return ({
    contractInfo: props,
    type: TypeActionContractInfo.Received,
}); };
export var actionContractInfoRequest = function () { return ({
    type: TypeActionContractInfo.Request,
}); };
export var actionContractRequestFulfill = function (contractId) { return ({
    contractId: contractId,
    type: TypeActionContractInfo.RequestFulfill,
}); };
export var actionContractFulfill = function (contractId) { return ({
    contractId: contractId,
    type: TypeActionContractInfo.Fulfill,
}); };
export var actionContractRequestDismiss = function (contractId) { return ({
    contractId: contractId,
    type: TypeActionContractInfo.RequestDismiss,
}); };
export var actionContractRequestSkip = function (contractId) { return ({
    contractId: contractId,
    type: TypeActionContractInfo.RequestSkip,
}); };
export var actionContractSkip = function (contractId, amount) { return ({
    amount: amount,
    contractId: contractId,
    type: TypeActionContractInfo.Skip,
}); };
export var actionContractStartCooldown = function (cooldownTime) { return ({
    cooldownTime: cooldownTime,
    type: TypeActionContractInfo.StartCooldown,
}); };
export var actionContractFinishCooldown = function () { return ({
    type: TypeActionContractInfo.FinishCooldown,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/market/actionContractInfo.ts
// module id = 89
// module chunks = 3